// src/components/GoogleLoginButton.tsx
import React from 'react';
import { GoogleLogin, CredentialResponse } from '@react-oauth/google';

interface GoogleLoginButtonProps {
    onSuccess: (response: CredentialResponse) => void;
    onError?: () => void;
}

// Botão só com o ícone do Google (círculo), sem o retângulo com texto do
// tipo "standard" — a lib @react-oauth/google já suporta isso nativamente
// via type="icon"/shape="circle", sem precisar de nenhum SVG customizado.
const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({
    onSuccess,
    onError
}) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <GoogleLogin
                onSuccess={onSuccess}
                onError={() => {
                    console.error('❌ Erro no login com Google');
                    onError?.();
                }}
                type="icon"
                shape="circle"
                size="large"
            />
        </div>
    );
};

export default GoogleLoginButton;
